import React, {useState} from 'react'
import './about.css'
import ME from '../../assets/me-about.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'
import {AboutData} from './AboutData'
function AboutMain(){
  const [description, setDescription]= useState('I am a Full Stack Software Engineer with experience in building secure, scalable, and cloud-native applications. I specialize in backend development, cloud deployments, CMS integrations, and modern frontend frameworks. My work improves platform security, system performance, and development efficiency across enterprise-scale systems.')
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <div className='about__me'>
          <div className='about__me-image'>
            <img src={ME} alt="About Image"/>
          </div>
        </div>
        <div className='about__content'>
          <div className='about__cards'>

           {AboutData.map((item,index)=>{
            return(
              <a onClick={()=>setDescription(item.description)}>
              <article className='about__card'>
                {item.icon}
                <h5>{item.title}</h5>
                <small>{item.subtitle}</small> 
              </article>
              </a>
              
              
            )
           })} 
            {/* <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>3+ Years as Software Engineer</small>               
            </article>

            <article className='about__card'>
              <FiUsers className='about__icon'/>
              <h5>Clients</h5>
              <small>Change this</small>               
            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>General</h5>
              <small>Info.</small>               
            </article> */}
            </div>
            <p>
              {description}
            </p>


            <a href="#contact" className='btn btn-primary'>Let's Talk</a>


        </div>
      </div>
    </section>
  )
}
const About= ()=>{
  return(
    <AboutMain/>
  )
}
export default About